// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"RoomType_cardContainer__3TwFT","marginRight":"RoomType_marginRight__N-pIp"};